<template>
  <div>
    <h1 class="display-3">Okres Czerwiec 41' - Lipiec 44'</h1><br/>

    <b-row>
      <b-col md="6" order-md="1" order="2">
        <p>
          Zajęcie Wileńszczyzny przez wojska niemieckie i inny podział administracyjny, zatwierdzenie przez Komendę Główną na
          Komendanta Okręgu Wileńskiego, ppłk Aleksandra Krzyżanowskiego „Wilk”, rozpoczęło nowy rozdział działalności
          konspiracyjnej Związku Walki Zbrojnej Okręgu.
        </p>
        <p>
          W połowie 1942 r. Komenda Główna przemianowała dotychczasowy Związek Walki Zbrojnej na Armię Krajową odróżniając część
          sił zbrojnych Polskiego Państwa Podziemnego od sił zbrojnych na zachodzie to jest jednostek walczących pod ogólnym
          dowództwem aliantów.
        </p>
        <p>
          Odtworzono Komendę Garnizonu miasta Wilna „Dwór”. Garnizon podzielono na cztery dzielnice. Zadaniem ich było przygotowanie,
          a następnie utworzenie Oddziałów wojskowych w sile Batalionu.<br/>
        </p>
      </b-col>
      <b-col md="5" order-md="2" order="1">
        <b-img center fluid src="/historia/okres_41_44/Podział_Okregu_Wilenskiego.jpg"/><br/>
        <span class="lead">Podział Okręgu Wileńskiego na Obwody (powiaty)</span>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="11">
        <p class="lead">
          „Pole” zostaje podzielone na trzy rejony :
        </p>
        <ul>
          <li v-for="el in okres_41_44.powiaty.list.rejony">{{el}}</li>
        </ul>
      </b-col>
    </b-row>

    <b-row class="justify-content-sm-center">
      <b-col v-for="card in okres_41_44.powiaty.cards" :key="card.id" md="3" cols="6">
        <b-card
          :img-src="card.img"
          img-top
          tag="article"
          style="width: 10em; min-height: 25em;"
          class="mb-2">
          <p class="card-text">
            {{card.desc}}
          </p>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="8">
        <ul>
          <li v-for="el in okres_41_44.powiaty.list.desc">{{el}}</li>
        </ul>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="11">
        <p>
          Poza Garnizonem miejskim i rejonami do Okręgu Wileńskiego należał Podokręg Kowieński.
          Powstają Komendy Rejonów i Obwodów wraz z siatką wywiadu i łączności. Powołana zostaje Komenda Dywersji „Kedyw”,
          którego Dowódcą zostaje por. Adam Boryczka „Tońko”, „Brona”.
        </p>
        <p>
          Ludność pochodzenia białoruskiego mieszkająca na Wileńszczyźnie w pełni zaakceptowała Związek Walki Zbrojnej i
          z nim współpracowała.
        </p>

        <p class="display-4 mt-3">Okręgowa Delegatura Rządu</p>
        <p>
          Po kilkukrotnych zmianach decyzji Głównego Delegata Rządu w Warszawie odnośnie kandydata na Okręgowego Delegata Rządu
          Okręgu Wileńskiego, na posiedzeniu Rady Wojewódzkiej pod przewodnictwem ppłk Aleksandra Krzyżanowskiego „Wesołowski”,
          „Dziemido”, „Wilk” w dniu 28 lutego 1942 r. wybrano przedstawiciela Stronnictwa Narodowego dr Zygmunta Fedorowicza „Albin”,
          „Pani Maria”, „Józef”.
        </p>
        <p class="lead">Wileńska Delegatura składała się z następujących komórek:</p>
        <ul>
          <li v-for="el in okres_41_44.okreg_deleg.list.wilno">{{el}}</li>
        </ul>
        <p>
          Kierownictwo Walki Cywilnej - występowało jako gremium Stronnictw Politycznych: Jerzy Dobrzański „Pan S” z ramienia PPS-WRN,
          Henryk Jackiewicz „Pan L” z ramienia SL, Edmund Greczanik „Pan D” z ramienia SD, Feliks Kasperowicz „Pan N” z ramienia SN, NN
          „Pan R” z ramienia ONR, Adam Galiński „Pan P” z ramienia piłsudczyków.
        </p>

        <p class="lead">Ponadto przy Delegacie Rządu działał:</p>
        <ul>
          <li v-for="el in okres_41_44.okreg_deleg.list.rzad">{{el}}</li>
        </ul>
      </b-col>
    </b-row>

    <b-row>
      <b-col v-for="card in okres_41_44.okreg_deleg.cards.part1" :key="card.id" md="3" cols="6">
        <b-card
          :img-src="card.img"
          img-top
          tag="article"
          style="width: 10em; min-height: 25em;"
          class="mb-2">
          <p class="card-text">
            {{card.desc}}
          </p>
        </b-card>
      </b-col>
      <b-col v-for="card in okres_41_44.okreg_deleg.cards.part2" :key="card.id" md="3" cols="6">
        <b-card
          :img-src="card.img"
          img-top
          tag="article"
          style="width: 10em; min-height: 25em;"
          class="mb-2">
          <p class="card-text">
            {{card.desc}}
          </p>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="11">
        <p class="display-4 mt-3">Komenda Okręgu Wileńskiego Armii Krajowej.</p>
      </b-col>
    </b-row>

    <b-row class="justify-content-md-center">
      <b-col md="10">
        <b-card>
          <b-row class="justify-content-md-center">
            <b-col md="3">
              <b-img center fluid src="/historia/okres_41_44/Aleksander_Krzyzanowski.jpg"/><br/>
            </b-col>
            <b-col md="5">
              <strong>Ppłk Aleksander Krzyżanowski „Andrzej Wesołowski”, „Smętek”, „Dziemido”, „Wilk”</strong>
              Drugi Komendant Związku Walki Zbrojnej i Armii Krajowej Okręgu Wileńskiego.
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="11">
        <p>
          Mjr Aleksander Krzyżanowski w listopadzie 1939 r. został skierowany przez gen. Karaszewicza-Tokarzewskiego do Wilna dokąd
          dotarł w lutym 1940 r. i objął stanowisko kwatermistrza Komendy Okręgu. W kwietniu 1940 r. został zastępcą Komendanta Sulika
          i jednocześnie szefem sztabu Komendy. Awansowany na stopień podpułkownika 22.01.1941 r. Po aresztowaniu ppłk Nikodema Sulika
          przejął obowiązki Komendanta Okręgu. W czasie pełnienia stanowiska Komendanta Okręgu podejmował kilkakrotnie próby uzgodnienia
          współdziałania Armii Krajowej z partyzantką sowiecką - bez powodzenia. Po zakończeniu walk o Wilno ppłk Krzyżanowski ujawnił
          się za zgodą Komendy Głównej jako generał Kulczycki i podjął rozmowy z dowództwem 3. Frontu Białoruskiego Czerwonej Armii.
          Aresztowany przez NKWD przebywał w więzieniach w Wilnie i w ZSRR. 28.09.1944 został awansowany na stopień pułkownika.
          Zwolniony w listopadzie 1947 r. i powrócił do Kraju. Aresztowany przez UB 02.07.1948 osadzony w więzieniu w Warszawie,
          gdzie 29.09.1951 r. zmarł. Awansowany pośmiertnie na stopień generała brygady.<br/>
          W lutym 1942 r. Związek Walki Zbrojnej, zostaje przemianowany na Armię Krajową. W połowie 1942 roku Komenda Główna Armii
          Krajowej w Warszawie, deleguje do Wilna mjr Lubosława Krzeszowskiego "Ludwik", który obejmuje stanowisko Szefa Sztabu Komendy
          Okręgu. Objęcie stanowiska przez "Ludwika" spowodowało reorganizację Okręgu. Podzielony on został na cztery Inspektoraty
          Rejonowe, które dzieliły się na Obwody terytorialnie obejmujące poszczególne powiaty. W każdym Obwodzie utworzony zostaje
          Ośrodek   Dywersyjny lub Dywersyjno-Partyzancki. Brak jest danych źródłowych, określających jakie zadania miały i w jakiej
          zależności były one w stosunku do siebie i Komend Inspektoratów Rejonowych. Wiadome jest, że Ośrodki Dywersyjno - Partyzanckie
          były podwaliną dla kadry i szkieletem mających powstać Oddziałów Partyzanckich. <br/>
          W początkach roku 1944 następuje ponowna reorganizacja Okręgu. Powstały Inspektoraty. Podlegały im działające lub powoływane
          na ich terenie Oddziały Partyzanckie, które następnie otrzymały nazwy Brygad Partyzanckich Armii Krajowej z numerem., a z czasem
          samorzutnie przyjęły nazwy od pseudonimów swoich komendantów.
        </p>

        <p class="lead mt-3">Obsada personalna Komendy Okręgu Wileńskiego była następująca:</p>
        <ul>
          <li v-for="el in okres_41_44.komenda.list.obsada">{{el}}</li>
        </ul>

        <p class="lead mt-3">Inspektoraty:</p>
        <ul>
          <li v-for="el in okres_41_44.komenda.list.inspektoraty">{{el}}</li>
        </ul>
      </b-col>
    </b-row>

    <b-row>
      <b-col v-for="card in okres_41_44.komenda.cards.part1" :key="card.id" md="3" cols="6">
        <b-card
          :img-src="card.img"
          img-top
          tag="article"
          style="width: 10em; min-height: 25em;"
          class="mb-2">
          <p class="card-text">
            {{card.desc}}
          </p>
        </b-card>
      </b-col>
      <b-col v-for="card in okres_41_44.komenda.cards.part2" :key="card.id" md="3" cols="6">
        <b-card
          :img-src="card.img"
          img-top
          tag="article"
          style="width: 10em; min-height: 25em;"
          class="mb-2">
          <p class="card-text">
            {{card.desc}}
          </p>
        </b-card>
      </b-col>
    </b-row>


    <b-row>
      <b-col cols="11">
        <div v-for="zgrupowanie in okres_41_44.komenda.zgrupowania" :key="">
          <p class="lead mt-3">{{zgrupowanie.title}}</p>
          <ul>
            <li v-for="el in zgrupowanie.list">{{el}}</li>
          </ul>
        </div>
        <p>
          Poza Zgrupowaniami Partyzanckimi działały 6. Brygada mjr "Konara" i Oddział Rozpoznawczy
          Komendanta Okręgu por. „Groma” oraz Garnizon miasta Wilna.
        <p>

        <p class="lead mt-2">Jednocześnie z powołaniem Zgrupowań, nastąpił podział sztabów na:</p>
        <ul>
          <li v-for="el in okres_41_44.komenda.list.sztaby">{{el}}</li>
        </ul>
        <p>
          Oba sztaby rozpoczęły przygotowania do Operacji "Ostra Brama" mającej za zadanie opanowanie miasta Wilna i jego najbliższych
          okolic w czasie odstępowania wojsk niemieckich, a zajęciem tych terenów przez wojska sowieckie. Operacja ta miała się odbyć z
          udziałem połączonych sił zbrojnych Armii Krajowej obu Okręgów Wileńskiego i Nowogródzkiego pod wspólnym dowództwem ppłk Aleksandra
          Krzyżanowskiego "Wilk". <br/>
          Dowództwo II Frontu Białoruskiego wojsk sowieckich kierowane przez marszałka Iwana Czerniahowskiego, przy ścisłej współpracy z
          zastępcą Ministra Spraw Wewnętrznych /NKWD/ Berii, generałem NKWD Iwanem Sierowem, realizując wcześniejsze uchwały Biura
          Politycznego ZSRR dotyczące zniszczenia fizycznego Armii Krajowej na terenach zajmowanych przez Związek Sowiecki przysłały swoich
          oficerów łącznikowych, celem ustalenia zasad prowadzenia wspólnych działań zbrojnych przeciwko Niemcom. Jak się później okazało
          nie byli to oficerowie liniowi wojsk frontowych, ale specjalnie przeszkoleni wyżsi oficerowie NKWD, mający za zadanie rozpoznanie
          sił Oddziałów Armii Krajowej, ich miejsca postoju, uzbrojenie, nastroje polityczne itd. <br/>
          Oficjalnie podawano, że Armia Krajowa Okręgów Wileńskiego i Nowogródzkiego będzie przemianowana na 19 Dywizję Wojsk
          Sprzymierzonych, podlegając politycznie Rządowi Polskiemu na Emigracji, natomiast taktycznie Dowództwu wojsk sowieckich.
          Wszystkie te deklaracje i działania zostały przez Komendę Okręgu przyjęte jako wiarygodne, a okazały się ogromnym kłamstwem.
          Efekty tych działań w rozdziale "Rozbrojenie i aresztowanie".
        </p>

        <p class="display-4 mt-4">Legalizacja</p>
        <p>
          Dowódca Oddziału VI Biuro Informacji i Propagandy - ppor. Leon Lech Bejnar "Nowina" /Paweł Jasienica/.
          W końcu 1939 roku wynikła bardzo pilna potrzeba utworzenia przy sztabie Okręgu Wileńskiego SZP komórki legalizacyjnej.
          Zadaniem jej byłoby wykonywanie dokumentów, którymi mogliby się posługiwać ludzie związani z konspiracją, oficerowie pragnący
          wstąpić do Wojska Polskiego we Francji po przez Litwę, Szwecję oraz tak zwani uchodźcy ,których w Wilnie było około 30 tysięcy.<br/>
          Ówczesne władze tak sowieckie jak i następnie litewskie żądały od ludzi znajdujących się w Wilnie , dokumentów uzasadniających ich pobyt na
          tych terenach.<br/>
          Otrzymano z likwidujących się polskich urzędów państwowych i samorządowych sporo czystych blankietów na dowody osobiste,
          zaświadczeń pracy, metryk urodzenia i tym podobnych.<br/>
          Na polecenie członka Sztabu Okręgu księdza Kazimierza Kucharskiego "Szymon" jego zaufany współpracownik Stanisław Kiałka
          "Bolesław" „Drzewica", "Jelonek" "Szarotka" otrzymał polecenie organizacji takiej komórki.<br/>
          Jednocześnie z poleceniem podał adres doc. Wydziału Sztuk Pięknych USB Jerzego Hoppena , który przyjął propozycję i włączył do
          tej pracy grafika Edwarda Kuczyńskiego "Kalina". Skład ten uzupełnił jako pracownik biurowy i fotograf ks. Stefan Dzierżek jezuita.
          Z poręczenia doc. Hopppena zgodziła się współpracować z Komórką Legalizacyjną firma cynkograficzna Zaniewskiego przy ul. Wielkiej.
          Trudności przy składaniu zleceń w firmie Zaniewskich, zmusiły doc. Hoppena do nawiązania współpracy ze studentem Wydziału Sztuk
          Pięknych USB metaloplastyki Michała Warakomskiego "Piotr", "Jacek" jako kierownika cynkografii na potrzeby Legalizacji.
          Po ustąpieniu doc. Hoppena ze względów zdrowotnych z tej pracy, w grudniu 1939 roku, jego miejsce zajął Romuald Warakomski
          "Hilary" jako grafik. Dział chemicznego "prania" zwłaszcza litewskich paszportów prowadziła studentka chemii USB Irena
          Butkiewiczówna "Irka Lwowska", "Renata". <br/>
          Legalizacja w okresie od grudnia 1939 do maja 1940 r. wypuściła około 3.000 różnych dokumentów.
          W marcu 1940 r. do pracy w Legalizacji przystąpiły siostry Józefa i Maria Rymkiewiczówne.
          W okresie od listopada 1940 r. do grudnia 1941 Legalizacja posiadała pracownie : graficzną, fotograficzną, cynkografię, warsztat wulkanizacyjny pieczęci i drukarnię.
          W tym okresie Legalizacją kierował - Stanisław Kiałka "Ślęczek", "Bolesław"
          "Kuźnią" obejmująca: cynkografię, warsztat wulkanizacyjny, drukarnię - Michał Warakomski "Piotr", "Jacek".
          Doradcą technicznym był - doc. Jerzy Hoppen .
          I grafikiem - Edward Kuczyński "Kalina".
          II grafikiem - Romuald Warakomski "Jerzy", "Hilary".
          Pracownicy Biurowi – Józefa Rymkiewicz „Ziuta” i Maria Rymkiewicz „Jaśmin”.
          Pracownia chemiczna - Irena Butkiewiczówna "Renata", "Irka Lwowska".
        </p>

        <p>
          Bardzo trudne warunki lokalowe Legalizacji oraz konieczność zmiany fotografa nastąpiła po przeprowadzeniu się komórki do
          mieszkania Stanisława Turskiego "Roman" fotografa i chemika.
          Wobec konieczności zlikwidowania skrzynki kontaktowej przyjmującej zamówienia na nowe dokumenty i przekazywania gotowych
          dokumentów, założono nową w mieszkaniu państwa Kafarskich przy ul. Dominikańskiej 2.
          Jednocześnie jako łączniczki Legalizacji z Komendą Okręgu zostały zaprzysiężone Józefa Kafarska "Wrzos" i Stanisława Kafarska
          "Hańcza". Ta skrzynka kontaktowa działała aż do stycznia 1945r.
          Nawał pracy i czasowe odejście z Legalizacji Stanisława Kiałki nastąpiły zmiany organizacyjne i w roku 1942 skład osobowy
          przedstawiał się następująco:
        </p>
        <p class="lead">„Kuźnia”:</p>
        <ul>
          <li v-for="el in okres_41_44.legalizacja.list.kuznia">{{el}}</li>
        </ul>

        <p>
          Od roku 1941 do 1943 Legalizacja posiadała pracownię przy ul. Zygmuntowskiej, w której wykończano opracowane dokumenty przed
          doręczeniem Komendzie Okręgu. W pierwszej połowie 1942 roku, nastąpiły aresztowania w komórkach podległych Komendzie Okręgu,
          a także zostali aresztowani z Legalizacji: Maria Tomkiewicz "Grażyna", Józefa Rynkiewicz "Ziuta" , Kowalska o nie ustalonym
          imieniu "Maria". Po bardzo ciężkim śledztwie i torturach zastosowanych przez będących w służbie niemieckiego Gestapa Litwinów,
          zostały zamordowane w Ponarach pod Wilnem nie wydając nikogo.
        </p>
        <p>
          W grudniu 1941 r. Romuald Warakomski "Hilary" stanowisko swoje przekazuje Halinie Turskiej "Aldona" docentowi filologii USB.
          Pracowali w niej starszy asystent filologii, asystentka przy tej katedrze oraz młody mężczyzna używający pseudonimu "Gucio",
          nazwisk ich nie dało się ustalić. Łączność prowadziły: Józefa Rymkiewicz "Ziuta", Maria Rymkiewicz "Jaśmin", Janina Doboszyńska.
        </p>
      </b-col>
    </b-row>

    <b-row>
      <b-col v-for="card in okres_41_44.legalizacja.cards.part1" :key="card.id" md="3" cols="6">
        <b-card
          :img-src="card.img"
          img-top
          tag="article"
          style="width: 10em; min-height: 25em;"
          class="mb-2">
          <p class="card-text">
            {{card.desc}}
          </p>
        </b-card>
      </b-col>
      <b-col v-for="card in okres_41_44.legalizacja.cards.part2" :key="card.id" md="3" cols="6">
        <b-card
          :img-src="card.img"
          img-top
          tag="article"
          style="width: 10em; min-height: 25em;"
          class="mb-2">
          <p class="card-text">
            {{card.desc}}
          </p>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="11">
        <p>
          Po aresztowaniu "Aldony" komórkę legalizacji przejęła Maria Sadowska "Wiesława", absolwentka Wydziału Sztuk Pięknych USB.
          Następna zmiana miejsca pracy tego działu Legalizacji do mieszkania państwa Mahrburgów wzbogaciło personel o trzy kobiety matkę
          i dwie córki. Anna miała pseudonim "Hanka". Jesienią 1943 r. dział fotografii przejął Zdzisław Pleskaczewski "Zbyszek".
          Sekcja łączności składała się z Stanisławy Smoter "Zośka", Jadwigi Dulównej "Jadzia" i Ireny Barszczewskiej "Lolka".
          Komórka legalizacyjna Okręgu Wileńskiego SZP, ZWZ, a następnie Armii Krajowej pracowała w zasadzie przez cały czas
          poszczególnych okupacji. Wykonała przeszło 35.000 różnych dokumentów koniecznych dla ludzi, którzy dzięki nim mogli
          działać w konspiracji, utrzymywać łączność kurierską tak z Warszawą jak i całą Europą. Była to praca bardzo ważna,
          bardzo niebezpieczna, a aresztowania w zasadzie kończyły się śmiercią po bardzo ciężkich śledztwach połączonych z torturami.
          Ludzie wymienieni w tym  opracowaniu z poczucia patriotyzmu, bezinteresownie spełniali swój patriotyczny obowiązek wiedząc,
          że żadna nagroda nigdy ich nie spotka. Działaniem swoim zasłużyli na pamięć potomnych.
        </p>

        <p class="display-4 mt-3">Tajne nauczanie</p>
        <p>
          Strajki młodzieży gimnazjalnej i związane z tym zaprzestanie nauki przez część uczniów oraz zamknięcie Uniwersytetu Stefana
          Batorego było powodem rozpoczęcia prowadzenia konspiracyjnego nauczania.
          Powołana w Wilnie Komenda Okręgu Służby Zwycięstwa Polski zgodnie z przyjętą strukturą organizacyjną miała tak zwany pion
          cywilny, którego jeden z departamentów miał się zajmować sprawami oświaty w zaistniałych warunkach.
          Rozwiązanie tej organizacji przez Rząd na Emigracji i przemianowanie jego na Związek Walki Zbrojnej odmieniło sytuację,
          ponieważ Związek ten nie miał w swoich strukturach organizacyjnych spraw cywilnych.
          Powstała konieczność zorganizowania nauczania młodzieży tego potrzebującej w warunkach konspiracyjnych. W zasadzie
          poszczególni nauczyciele tak gimnazjalni jak i profesorowie uniwersyteccy zaczęli skupiać młodzież pragnącą uczyć się dalej.
          Fenomenem tej działalności była jej masowość. Młodzież podejmując naukę na tak zwanych kompletach traktowała to jako
          działalność niepodległościową, przeciwstawiając się w ten sposób okupantom. Nauczyciele, kompletując zespół uczniów również
          musieli spełniać   warunki konspiracji tak w doborze uczniów jak i warunków nauczania.
          Pierwszymi organizatorami i koordynatorami tego działania w zakresie gimnazjum byli : prof. Uniwersytetu Stefana Batorego
          Stanisław Hiller, Janina Bohdanowiczówna, dyrektorka gimnazjum im. Czartoryskiego i ks. HenrykHlebowicz.
          Powstała Tajna Organizacja Nauczycielska kierowana przez Stanisława Zdybka. W tym okresie w kierownictwie organizacji
          działał późniejszy Okręgowy Delegat Rządu Zygmunt Fedorowicz. Łącznikiem "Tajnego Nauczania" w Wilnie do kontaktów z Warszawą
          był Stanisław Lisowski były przewodniczący Oddziału Związku Nauczycielstwa Polskiego.
        </p>
        <p class="lead">
          Organizacją tajnego nauczania na poziomie uniwersyteckim zajmował się
          prof. Stanisław Hiller, prodziekan zamkniętego przez okupantów Uniwersytetu Stefana Batorego.
        </p>
        <p>
          Na początku 1942 roku kierownikiem tajnego nauczania powszechnego i gimnazjalnego został Jan Bobko, były naczelnik
          Wydziału Szkolnictwa Średniego w Kuratorium. Po powołaniu urzędu Delegata Rządu Okręgu Wileńskiego, Jan Bobko został
          kierownikiem Wydziału Oświaty w Delegaturze, następcą jego został Stanisław Starościak, były inspektor szkolny. Prof.
          Stanisław Hiller poświęcił się wykładom na Tajnym Wydziale Lekarskim. Po ustąpieniu Jana Bobko ze stanowiska kierownika
          Wydziału Oświaty w Okręgowej Delegaturze Rządu, miejsce to objął były dyrektor gimnazjum im. Zygmunta Augusta Jan Żelski.
        </p>

        <p class="lead">
          Dla usprawnienia działań w zakresie tajnego nauczania, miasto Wilno zostało podzielone na
          trzy ośrodki na poziomie szkół średnich.
        </p>
        <ul>
          <li v-for="el in okres_41_44.tajne.list.osrodki">{{el}}</li>
        </ul>
        <p>
          Ośrodki miały oddzielnych kierowników odpowiedzialnych za nauczanie podstawowe. Między innymi byli to Apolonia
          Makarewiczowa i Stanisław Zdybek.
        </p>

        <p class="lead">
          O zakresie tajnego nauczania świadczy ilość uzyskanych świadectw maturalnych w latach:
        </p>
        <ul>
          <li v-for="el in okres_41_44.tajne.list.swiadectwa">{{el}}</li>
        </ul>
        <p>
          Wszyscy oni uzyskali matury eksternistyczne. Są to dane tylko z "Ośrodka Uniwersyteckiego" kierowanego przez prof.
          Władysława Dziewulskiego. Przez cały okres trwania tajnego nauczanie na poziomie uniwersyteckim rektorem Tajnego
          Uniwersytetu Stefana Batorego był prof. Stefan Ehrenkreutz.
          Dziekanem Tajnego Wydziału Lekarskiego był prof. Michał Reicher "Sosna", który w drugiej połowie 1941 musiał opuścić Wilno.
          Stanowisko dziekana objął prof. Stanisław Legeżyński, równolegle na tym Wydziale prowadzone były studia farmaceutyczne,
          którymi kierował prof. Jan Muszyński. Wykładali tam farmację mgr Henryk Zajączkowski, późniejszy
          Szef Farmacji Okręgu Wileńskiego, dr med. Wiktor Dunin-Horkiewicz "Kamil", dr med. Feliks Olesiński , dr. med.
          Stefan Cierpiński "Korwin". Na konspiracyjnym   Wydziale lekarskim studiowało w okresie okupacji ponad 200 osób.
        </p>

        <p class="lead">
          Dziekanem Wydziału Humanistycznego był prof. Jan Oko, zastępcą prof.
          Tadeusz Czeżowski, natomiast wykłady prowadzili profesorowie :
        </p>
        <ul>
          <li v-for="el in okres_41_44.tajne.list.profesorowie">{{el}}</li>
        </ul>

      </b-col>
    </b-row>

    <b-row>
      <b-col v-for="card in okres_41_44.tajne.cards" :key="card.id" xl="2" md="4" cols="6">
        <b-card
          :img-src="card.img"
          img-top
          tag="article"
          style="width: 10em; min-height: 25em;"
          class="mb-2">
          <p class="card-text">
            {{card.desc}}
          </p>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="11">
        <p>
          Wydział Teologiczny kontynuował nauczanie w ramach Seminarium Duchownego do 3 marca 1942 roku, kiedy to wszyscy wykładowcy
          zostali aresztowani przez Niemców. Na wydziale Prawa i Nauk Społecznych wykłady systematycznie prowadzili profesorowie :
          Stefan Ehrenkreutz, Iwo Jaworski, Kazimierz Petrusewicz, Bronisław Wróblewski, docent Witold Świda i ks. Bronisław Żongołłowicz.
        </p>

        <p class="lead mt-3">Na Wydziale Matematyczno - Przyrodniczym wykładali profesorowie:</p>
        <ul>
          <li v-for="el in okres_41_44.tajne.list.prof_mat_prz">{{el}}</li>
        </ul>
        <p>
          Ze studentami Wydziału Sztuk Pięknych pracowali profesorowie : Bronisław Jamont, Tymon Niesiołowski i Stefan Narębski.
          Dzięki poświęceniu i pomimo zagrożenia aresztowaniem Tajne Nauczanie na poziomie Uniwersyteckim i szkolnictwa gimnazjalnego,
          Polacy mieszkający na Wileńszczyźnie posiadali kadrę ludzi wykształconych, zasilając kadrę naukową w szkołach i uczelniach
          polskich po opuszczeniu Wilna.
        </p>

        <p class="display-4 mt-3">Służby sanitarne</p>
        <p>
          Sytuacja jaka wytworzyła się w Wilnie po 17 września 1939 r. spowodowała konieczność zorganizowania opieki medycznej nad ludźmi,
          którzy znaleźli się na tamtym terenie pozbawieni środków do życia, a w przypadku zachorowania opieki lekarskiej. Organizacje
          społeczne bardzo skutecznie, zajęły się tym problemem.
        </p>
        <div v-for="sluzba in okres_41_44.sluzby" :key="sluzba.id">
          <p class="lead mt-3">{{sluzba.title}}</p>
          <ul>
            <li v-for="el in sluzba.list">{{el}}</li>
          </ul>
          <p v-if="sluzba.text">{{sluzba.text}}</p>
        </div>
        <b-img center fluid src="/historia/okres_41_44/schemat_org_sluzby_sanitarnej.jpg"/><br/>

        <p class="display-4 mt-3">Sowieckie represje</p>
        <p>
          Przekroczenie przez wojska sowieckie granic Państwa Polskiego w dniu 17 września 1939 r. bez wypowiedzenia zawartego paktu o
          nieagresji i bez wypowiedzenia wojny był pierwszym sygnałem realizacji doktryny bolszewickiej wyniszczenia narodu polskiego.
          Natychmiast po wkroczeniu drugiej linii wojsk składających się z doborowych jednostek NKWD, rozpoczęły się aresztowania w
          pierwszym rzędzie inteligencji polskiej bez względu na ich zachowania i poglądy polityczne.
          Aresztowania takie trwały przez cały okres pierwszej okupacji sowieckiej z okresowymi falami masowych aresztowań i wywózek na
          "Nieludzką Ziemię".
          W świetle przytoczonych dokumentów sowieckich szczegółowe omawianie tych spraw staje się nie celowe.
          Przytoczone poniżej chronologicznie podawane dokumenty, każdemu powinny nasunąć odpowiednie wnioski.
          W świetle dokumentów archiwalnych przekazanych Rzeczypospolitej Polskiej przez władze Rosji w latach 90-tych XX wieku, a
          dotyczących okresu II wojny Światowej, można z dużym prawdo podobieństwem stwierdzić, że wojska NKWD i straży więziennej na
          podstawie decyzji Biura Politycznego podjętej w sprawie jeńców wojennych i osób aresztowanych w 1939 r. i przebywających w
          więzieniach na początkach 1940 r. dokonały masowych mordów osób zatrzymanych i przebywających w więzieniach na terenie
          województwa  wileńskiego.
          Mordów takich w drugiej połowie czerwca 1941 r. dokonano w więzieniach w Berezweczu, Starej Wilejce. Święcianach, na Łukiszkach
          w Wilnie. Więźniów których nie mogli wywieźć w głąb ZSSR, wymordowano z broni maszynowej na podwórzach więziennych lub w
          celach. Szacuje się, że zginęło wówczas około 2.500 osób. Nigdy nikt ani mocodawców ani wykonawców tych mordów nie oskarżył
          ani ukarał. Polityka likwidacji obywateli narodowości polskiej, którzy znaleźli się na terenach okupowanych przez sowietów trwała nadal.
          Należy pamiętać o tym, że granice wschodnie Rzeczypospolitej Polskiej a Związkiem Socjalistycznych Republik Radzieckich zostały
          zmienione dopiero 10 marca 1946 r. Granice te zostały ustalone traktatem podpisanym przez te same państwa w 1921 r.
          Odkrycie przez Niemców w 1942 r. masowych grobów polskich oficerów w Katyniu na Białorusi, zbadanie ich przez powołaną
          Międzynarodową Komisję Specjalistów oraz wydania przez nią orzeczenia stwierdzającego czas śmierci tych osób wraz z częściowym
          ich rozpoznaniem, na podstawie odnalezionych przy zwłokach dokumentów dało prawo zwrócenia się przez Rząd Polski na Emigracji
          do Międzynarodowego Czerwonego Krzyża w Genewie o szczegółowe zbadanie tej sprawy, wobec oficjalnego wypierania się przez rząd
          sowiecki dokonania tej zbrodni.
          Wystąpienie to stało się powodem zerwania przez Rząd sowiecki stosunków dyplomatycznych z Rzeczypospolitą Polską.
          Zerwanie stosunków dyplomatycznych uniemożliwiło na bardzo długi okres wyjaśnienia tych spraw, a władzy sowieckiej kontynuowania
          w dalszym ciągu polityki eksterminacji obywateli polskich. Kontynuowania takiej obłudnej polityki.
          Przytoczone dalej dokumenty potwierdzają kontynuowanie takiej polityki.
        </p>

        <b-card class="mt-5">
          <strong>
            Do wszystkich Brygad i Oddziałów.<br/>
            Stanowisko Centralnych Komitetów Komunistycznych Partii Ukrainy, Białorusi i Litwy w Moskwie.<br/>
            Dnia 22 czerwca 1943 r.<br/>
          </strong>
          <i>
            <p class="mt-3">
              Pismo okólna.<br/>
              O wojskowo- politycznych zadaniach pracy w zachodnich Obwodach Białorusi.
            </p>
            <p>
              <ol>
                <li>Zachodnie Obwody radzieckich Białorusi, stanowią integralną część Republiki Białoruskiej.</li>
                <li>Na zajętym przez Niemców terytorium Białorusi dopuszczalne jest tylko działalność, która kieruje się interesami mas pracujących państwa radzieckiego.</li>
                <li>Istnienie różnorodnych organizacji kierowanych przez polskie burżuazyjne ośrodki, należy traktować jako bezprawne wtrącanie się do spraw naszego Kraju.</li>
                <li>Nasze główne zadanie sprowadza się do tego, aby szerzej rozwijać radziecki ruch partyzancki, wciągając do niego wszystkie warstwy ludności, w tym i Polaków.</li>
                <li>Nacjonalistyczne oddziały i grupy tworzone przez Polskie koła reakcyjne, należy izolować od ludzi pracy, narodowości polskiej.</li>
                <li>Wszelkimi sposobami zwalczać Oddziały i grupy nacjonalistyczne.</li>
              </ol>
            </p>
          </i>
        </b-card>

        <b-card class="mt-5">
          <strong>
            Egzemplarz Nr 7<br/>
            Ściśle tajne. Surowo tajne, wcześniejsze ujawnienie karalne<br/>
            Rozkaz bojowy.<br/>
            Do Komendantów i Komisarzy Oddziałów Partyzanckich, Brygady im. Stalina.<br/>
            30 listopada 1943 r. - godz. 15.00<br/>
          </strong>
          <i>
            <p class="mt-3">
              W wykonaniu rozkazu Naczelnika Głównego Sztabu Ruchu Partyzanckiego przy Kwaterze Naczelnego Dowództwa Czerwonej Armii gen.
              por. Ponomarenki i upoważnionego Głównego Sztabu Ruchu Partyzanckiego w Kwaterze Naczelnego Dowództwa WKB/b/B. SZ. O.
              Baranowickiego Okręgu gen. maj. Płatonowa, w dniu 1 grudnia 1943 r. ogłosić punktualnie o godz. 7 rano, by we wszystkich
              zajętych punktach rejonu, przystąpić do osobistego rozbrajania wszystkich polskich legionistów /partyzantów/. Odebraną broń
              i dokumenty zarejestrować, a zespół legionistów razem z odebraną bronią, dostarczyć do polskiego obozu Miłaszewskiego w
              rejonie wsi Niestorowicze, iwińskiego rejonu. W razie oporu w czasie rozbrajania ze strony legionistów /partyzantów /
              rozstrzeliwać na miejscu.
            </p>
            <p>
              Z chwilą otrzymania niniejszego rozkazu natychmiast należy rozesłać go, ściśle poufnymi listami do wykonania w rejony
              operacyjne waszych grup, kompanii i plutonów ze zleceniem wykonania niniejszego rozkazu.
            </p>
            <p>Rozkaz należy trzymać w ścisłej tajemnicy.</p>
            <p>Za ujawnienie tego rozkazu z jakich by nie było powodów, będą osobiście odpowiadać Dowódca Oddziałów.</p>

            <p class="text-right">
              Komendant Brygady im. Stalina /-/ płk Gulewicz<br/>
              Komisarz Brygady im. Stalina /-/ płk Muranow<br/>
              Naczelnik Sztabu Brygady im. Stalina /-/ ppłk Karpow
            </p>
          </i>
        </b-card>

        <p class="lead mt-5">Odbito 10 egzemplarzy</p>
        <ul>
          <li v-for="el in okres_41_44.odbitki.list">{{el}}</li>
        </ul>

      </b-col>
    </b-row>

  </div>
</template>

<script>
import okres_41_44 from '@/models/historia/okres_41_44'
export default {
  name: 'okres_41_44',
  data: function(){
    return{
      okres_41_44: okres_41_44
    }
  },
  metaInfo:{
    title: 'Okres Czerwiec 41\' - Lipiec 44\'',
    meta:[
      {name: 'description', content: 'Zajęcie Wileńszczyzny przez wojska niemieckie i inny podział administracyjny, zatwierdzenie przez Komendę Główną na Komendanta Okręgu Wileńskiego, ppłk Aleksandra Krzyżanowskiego „Wilk”, rozpoczęło nowy rozdział działalności konspiracyjnej Związku Walki Zbrojnej Okręgu.' },
      {name: 'og:url', content: 'http://akwilno.pl/historia/okres_41_44' },
      {name: 'og:title', content: 'Okres Czerwiec 41\' - Lipiec 44\'' },
      {name: 'og:image', content: '/historia/okres_41_44.jpg' },
      {name: 'og:description', content: 'Zajęcie Wileńszczyzny przez wojska niemieckie i inny podział administracyjny, zatwierdzenie przez Komendę Główną na Komendanta Okręgu Wileńskiego, ppłk Aleksandra Krzyżanowskiego „Wilk”, rozpoczęło nowy rozdział działalności konspiracyjnej Związku Walki Zbrojnej Okręgu.' },
      {name: 'twitter:url', content: 'http://akwilno.pl/historia/okres_41_44' },
      {name: 'twitter:title', content: 'Okres Czerwiec 41\' - Lipiec 44\'' },
      {name: 'witter:image', content: '/historia/okres_41_44.jpg' },
      {name: 'twitter:description', content: 'Zajęcie Wileńszczyzny przez wojska niemieckie i inny podział administracyjny, zatwierdzenie przez Komendę Główną na Komendanta Okręgu Wileńskiego, ppłk Aleksandra Krzyżanowskiego „Wilk”, rozpoczęło nowy rozdział działalności konspiracyjnej Związku Walki Zbrojnej Okręgu.' }
    ]
  }
}
</script>



// WEBPACK FOOTER //
// src/components/historia/okres_41_44.vue